import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router';
import Icon from '/@/components/icon';
import colors from '/@/components/theme-provider/colors';
import { _ } from '/@/locale';
import useIsMobile from '/@/utils/hooks/is-mobile';
import { reverse } from '/@/utils/router';
import Title from '/@/v3/components/title';
import Background from '../../views/frost-risk/frost-risk-landing/assets/bg.svg';

const FrostRiskReco = ({ view = 'simplified' }) => {
    const history = useNavigate();
    const isMobile = useIsMobile();
    const simplified = view === 'simplified' || isMobile;
    return (
        <Box
            sx={{
                backgroundImage: `url(${Background})`,
                m: 2,
                borderRadius: 4,
            }}
        >
            <Box
                sx={{
                    background: `linear-gradient(0deg, transparent, black)`,
                    px: simplified ? 2 : 4,
                    py: simplified ? 3 : 6,
                    borderRadius: 4,
                }}
            >
                <Grid
                    container
                    direction={simplified ? 'column' : 'row'}
                    alignItems='center'
                    justifyContent='space-between'
                    spacing={3}
                >
                    <Grid item container spacing={3} direction='column' xs={simplified ? 12 : 6}>
                        <Grid item container justifyContent='space-between' alignItems='center'>
                            {simplified && (
                                <Grid item sx={{ width: 'fit-content' }}>
                                    <Icon type='frostRisk' size='xxl' style={{ filter: 'brightness(0) invert(1)' }} />
                                </Grid>
                            )}

                            <Grid item sx={{ width: 'fit-content' }}>
                                <Chip
                                    label={_('Nuevo lanzamiento')}
                                    size='small'
                                    sx={{
                                        backgroundColor: colors.themes.dekalb.primary[700],
                                        color: 'white !important',
                                        fontWeight: 600,
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid item container spacing={2} alignItems='center'>
                            {!simplified && (
                                <Grid item>
                                    <Icon type='frostRisk' size='xxl' style={{ filter: 'brightness(0) invert(1)' }} />
                                </Grid>
                            )}
                            <Grid item>
                                <Title color='white' size='xl' bolder>
                                    {_('Mapas de riesgo de heladas')}
                                </Title>
                            </Grid>
                        </Grid>
                        {simplified && (
                            <Grid item sx={12}>
                                <Divider variant='middle' sx={{ background: 'white', mx: 0 }} />
                            </Grid>
                        )}
                        <Grid item>
                            <Title color='white' size='md'>
                                {_(
                                    'Te traemos una nueva herramienta para poder elegir con mayor seguridad tu fecha de siembra. '
                                )}
                            </Title>
                        </Grid>
                    </Grid>
                    <Grid item xs={simplified ? 12 : 4} sx={{ width: '100%' }}>
                        <Button
                            fullWidth
                            size='small'
                            variant='contained'
                            color='white'
                            onClick={() => history(reverse('frost_risk'))}
                            endIcon={!simplified && <ArrowForwardIcon />}
                        >
                            {_('Ir a riesgo de heladas')}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default FrostRiskReco;
